import React from 'react'

function CoverLetter() {
  return (
    <div>
<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSEW2VHuvHcO-GgC6110NsMtkXXCB56AKGung&usqp=CAU"/>

    </div>
  )
}

export default CoverLetter
